import {
    Alert,
    Button,
    Checkbox,
    Collapse,
    Descriptions,
    Divider, Dropdown,
    Menu,
    message,
    Modal,
    Popconfirm,
    Popover,
    Progress,
    Radio,
    Space, Switch, Tag,
    Tooltip,
    Typography
} from "antd";
import {
    CheckOutlined,
    DeleteOutlined,
    FileImageOutlined,
    FileOutlined,
    SearchOutlined,
    StopOutlined,
    VideoCameraOutlined,
    AudioOutlined,
    SettingOutlined,
    DownOutlined,
    MacCommandFilled,
    MacCommandOutlined,
    CloseCircleOutlined,
    FontSizeOutlined,
    DownloadOutlined,
    UndoOutlined,
    EyeInvisibleOutlined,
    FilterOutlined,
    RetweetOutlined, FileTextOutlined, InfoCircleOutlined
} from "@ant-design/icons";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useSelectedAssetsDispatch, useSelectedAssetsState} from "../../contexts/SelectedAssetsContext";
import {useAggsState, useFacets} from "../../contexts/AggsContext";
import {useLoadedAssetsState} from "../../contexts/LoadedAssetsContext";
import DownloadButton from "./DownloadButton";
import filesize from 'filesize'
import {useSelectedAggsState} from "../../contexts/SelectedAggsContext";
import {GlobalHotKeys} from "react-hotkeys";

import {
    isBrowser,
} from "device-detect";
import useSelectAll from "../helpers/useSelectAll";
import useCurrentUser from "../helpers/useCurrentUser";
import {useFilters} from "../helpers/useFilters";
import {AbilityContext} from "../helpers/Can";
import {useTranslation} from "react-i18next";
import ShareButton from "@/components/explore/ShareButton";
import {BulkEditAssetMenu} from "~/components/explore/BulkEditButton";
import {useBulkJobsState} from "../../contexts/BulkJobsContext";
import api from "../api";
import VerticalSpace from "~/components/helpers/VerticalSpace";
import IsolatedDiv from "@/components/helpers/IsolatedDiv";

export default ({})=> {
    const {t} = useTranslation();
    const {selectedAssetIds, reloads: selectedAssetReloads} = useSelectedAssetsState();

    const {assetsLoading} = useLoadedAssetsState();

    const {total} = useAggsState()
    const currentUser = useCurrentUser()
    const {filters, removeFilter} = useFilters()
    // ---------------------------------------

    const {selectingAll, selectAll, selectNone, toggleSelect} = useSelectAll()

    const clickSelectNone = ()=>{
        selectNone()
        setTimeout(()=> removeFilter('selection'), 100)
    }

    const ref = useRef();
    const keyMap = {
        CMD_A: 'command+a',
    }

    const handlers = {
        CMD_A: (e) => {
            toggleSelect()
            e.preventDefault()
        },
    }

    return (
        <GlobalHotKeys keyMap={keyMap} handlers={handlers} innerRef={ref} allowChanges>
            <Space direction={'horizontal'}>
                {!!selectedAssetIds?.length || filters.selection ? (
                    <>
                        {currentUser && <BulkActionsButton/>}
                        <DownloadButton/>
                        <ShareButton small/>
                        <Dropdown.Button
                            size={'small'}
                            onClick={clickSelectNone}
                            loading={assetsLoading}
                            icon={<CheckOutlined />}
                            type={'primary'}
                            ghost
                            menu={{items:[]}}
                            buttonsRender={([left, right])=> [React.cloneElement(left, {id: 'select-all-btn'}), (
                                <AssetStoragePopover>
                                    <div aria-label={t('selected-assets-menu', 'Selected Assets Menu')}>
                                        {React.cloneElement(right, {icon: '...'})}
                                    </div>
                                </AssetStoragePopover>
                            )]}
                        >
                            <Tooltip title={<>{t('tooltip-select-none','Select None')}: <MacCommandFilled/> A</>} trigger={['hover','focus']}>
                                <CheckOutlined/>
                                {n(selectedAssetIds.length)} / {n(total) || '...'} {(isBrowser() && <>&nbsp;Asset{selectedAssetIds.length == 1 ? '' : 's'} {t('selected','Selected')}</>) || <FileOutlined/>}
                                {filters.selection && <FilterOutlined style={{color: Colors.red}}/>}
                            </Tooltip>
                        </Dropdown.Button>
                    </>
                ) : (
                    <Dropdown.Button
                        size={'small'}
                        onClick={selectAll}
                        loading={assetsLoading || selectingAll}
                        menu={{items:[]}}
                        buttonsRender={([left, right])=> [React.cloneElement(left, {id: 'select-all-btn'}), (
                            <AssetStoragePopover>
                                <div aria-label={t('selected-assets-menu', 'Selected Assets Menu')}>
                                    {right}
                                </div>
                            </AssetStoragePopover>
                            )]}
                    >
                        <Tooltip title={<>{t('tooltip-select-all','Select All')}: <MacCommandFilled/> A</>} trigger={['hover','focus']}>
                            {n(total)} {(isBrowser() && <>&nbsp;{t(`asset${total != 1 ? 's' : ''}`,`Asset${total != 1 ? 's' : ''}`)}</>) || <FileOutlined/>}
                        </Tooltip>
                    </Dropdown.Button>
                )}
            </Space>
        </GlobalHotKeys>
    )
}

const CsvDownloadModal = ({open, onClose, assetIds}) => {
    const {t} = useTranslation();
    const [sendEmail, setSendEmail] = useState(false)
    const [guid, setGuid] = useState()
    const [visible, setVisible] = useState(false)
    const [columnPreset, setColumnPreset] = useState('basic')
    const [availableColumns, setAvailableColumns] = useState(null)
    const [selectedColumns, setSelectedColumns] = useState([])
    const {metaDownloads} = useBulkJobsState()
    const progress = metaDownloads[guid]
    const done = progress?.done
    const error = progress?.error
    const processing = guid && !done && !error

    // Sync: parent opening the modal
    useEffect(() => {
        if(open) setVisible(true)
    }, [open])

    // Fetch available columns when switching to custom or all
    useEffect(() => {
        if((columnPreset === 'custom' || columnPreset === 'all') && !availableColumns) {
            api.get('/api/meta_downloads/columns').then(res => {
                setAvailableColumns(res.data.columns)
                setSelectedColumns(res.data.basic)
            })
        }
    }, [columnPreset])

    useEffect(() => {
        if(done && progress?.key) {
            const link = document.createElement('a');
            link.href = `/api/downloads/table_data?key=${progress.key}`;
            link.download = progress.key.substr(progress.key.lastIndexOf('/') + 1);
            link.click();
        }
    }, [done])

    const handleStart = () => {
        const params = {
            asset_ids: assetIds.join(','),
            send_email: sendEmail ? 'true' : 'false',
            column_preset: columnPreset,
        }
        if(columnPreset === 'custom') {
            params.columns = selectedColumns
        }
        api.post('/api/download_meta', params).then(res => {
            setGuid(res.data.guid)
        })
    }

    const toggleSendEmail = (checked) => {
        setSendEmail(checked)
        if(guid) {
            api.put(`/api/download_meta/${guid}`, { send_email: checked ? 'true' : 'false' })
        }
    }

    const handleClose = () => {
        setVisible(false)
        onClose()
    }

    const afterClose = () => {
        if(!processing) {
            setGuid(null)
            setSendEmail(false)
            setColumnPreset('basic')
            setSelectedColumns([])
        }
    }

    return (
        <Modal
            title={t('modal-csv-download-title', 'Download Metadata CSV')}
            open={visible}
            onCancel={handleClose}
            afterClose={afterClose}
            footer={null}
        >
            {guid ? (
                <div style={{textAlign: 'center', padding: '16px 0'}}>
                    <Progress
                        type="circle"
                        percent={progress?.progress || 0}
                        status={error ? 'exception' : done ? 'success' : 'active'}
                    />
                    <div style={{marginTop: 16}}>
                        {error && <Typography.Text type="danger">{error}</Typography.Text>}
                        {done && <Typography.Text type="success">{t('csv-download-complete', 'Download complete!')}</Typography.Text>}
                        {processing && <Typography.Text type="secondary">{t('csv-download-processing', 'Generating CSV...')}</Typography.Text>}
                    </div>
                    {processing && (
                        <>
                            <div style={{marginTop: 16}}>
                                <Checkbox
                                    checked={sendEmail}
                                    onChange={e => toggleSendEmail(e.target.checked)}
                                >
                                    {t('checkbox-email-csv', 'Email me when ready')}
                                </Checkbox>
                            </div>
                            <Alert
                                type="info"
                                showIcon
                                style={{marginTop: 16, textAlign: 'left'}}
                                message={t('csv-download-background-info', 'You can close this dialog — the CSV will download automatically in this browser tab when ready, or check the box above to receive it by email.')}
                            />
                        </>
                    )}
                    {(done || error) && (
                        <Button onClick={handleClose} style={{marginTop: 16}}>
                            {t('button-ok', 'OK')}
                        </Button>
                    )}
                </div>
            ) : (
                <Space direction="vertical" style={{width: '100%'}} size="middle">
                    <Typography.Text>
                        {t('csv-download-description', 'Export metadata for {{count}} selected assets as CSV.', {count: assetIds.length})}
                    </Typography.Text>

                    <div>
                        <Typography.Text strong style={{display: 'block', marginBottom: 8}}>
                            {t('columns-label', 'Columns')}
                        </Typography.Text>
                        <Radio.Group value={columnPreset} onChange={e => setColumnPreset(e.target.value)}>
                            <Radio.Button value="basic">{t('basic', 'Basic')}</Radio.Button>
                            <Radio.Button value="all">{t('all', 'All')}</Radio.Button>
                            <Radio.Button value="custom">{t('custom', 'Custom')}</Radio.Button>
                        </Radio.Group>
                    </div>

                    {columnPreset === 'basic' && (
                        <Typography.Text type="secondary">
                            {t('basic-columns-description', 'GUID, filename, created/captured/updated dates, auto tags, creator, rating, description, usage terms, title, headline, alt text, person names, credit line, IPTC rights, tag names, and any custom metadata fields.')}
                        </Typography.Text>
                    )}

                    {columnPreset === 'all' && availableColumns && (
                        <div style={{maxHeight: 300, overflow: 'auto', border: '1px solid #d9d9d9', borderRadius: 6, padding: 4}}>
                            <Collapse size="small" ghost>
                                {Object.entries(
                                    availableColumns.reduce((groups, col) => {
                                        (groups[col.group] = groups[col.group] || []).push(col);
                                        return groups;
                                    }, {})
                                ).map(([group, cols]) => (
                                    <Collapse.Panel
                                        key={group}
                                        header={<span>{group} <Typography.Text type="secondary">({cols.length})</Typography.Text></span>}
                                    >
                                        <div style={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                            {cols.map(col => (
                                                <Typography.Text key={col.key} type="secondary">{col.label}</Typography.Text>
                                            ))}
                                        </div>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    )}

                    {columnPreset === 'custom' && availableColumns && (
                        <div style={{maxHeight: 300, overflow: 'auto', border: '1px solid #d9d9d9', borderRadius: 6, padding: 4}}>
                            <Collapse size="small" ghost>
                                {Object.entries(
                                    availableColumns.reduce((groups, col) => {
                                        (groups[col.group] = groups[col.group] || []).push(col);
                                        return groups;
                                    }, {})
                                ).map(([group, cols]) => (
                                    <Collapse.Panel
                                        key={group}
                                        header={
                                            <span>
                                                {group}
                                                <Typography.Text type="secondary" style={{marginLeft: 8}}>
                                                    ({cols.filter(c => selectedColumns.includes(c.key)).length}/{cols.length})
                                                </Typography.Text>
                                            </span>
                                        }
                                    >
                                        <Space size={4} style={{marginBottom: 8}}>
                                            <Button
                                                size="small"
                                                type="link"
                                                style={{padding: 0}}
                                                onClick={() => {
                                                    const otherKeys = selectedColumns.filter(k => !cols.find(c => c.key === k))
                                                    setSelectedColumns([...otherKeys, ...cols.map(c => c.key)])
                                                }}
                                            >
                                                {t('select-all', 'Select All')}
                                            </Button>
                                            <Button
                                                size="small"
                                                type="link"
                                                style={{padding: 0}}
                                                onClick={() => {
                                                    const groupKeys = cols.map(c => c.key)
                                                    setSelectedColumns(selectedColumns.filter(k => !groupKeys.includes(k)))
                                                }}
                                            >
                                                {t('select-none', 'Select None')}
                                            </Button>
                                        </Space>
                                        <Checkbox.Group
                                            value={selectedColumns}
                                            onChange={checked => {
                                                const otherKeys = selectedColumns.filter(k => !cols.find(c => c.key === k))
                                                setSelectedColumns([...otherKeys, ...checked])
                                            }}
                                            style={{display: 'flex', flexDirection: 'column', gap: 4}}
                                        >
                                            {cols.map(col => (
                                                <Checkbox key={col.key} value={col.key}>
                                                    {col.label}
                                                </Checkbox>
                                            ))}
                                        </Checkbox.Group>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    )}

                    <Checkbox
                        checked={sendEmail}
                        onChange={e => setSendEmail(e.target.checked)}
                    >
                        {t('checkbox-email-csv', 'Email me when ready')}
                    </Checkbox>
                    <Button
                        onClick={handleStart}
                        type="primary"
                        icon={<DownloadOutlined/>}
                        block
                        disabled={columnPreset === 'custom' && selectedColumns.length === 0}
                    >
                        {t('button-start-csv-download', 'Start Export')}
                    </Button>
                </Space>
            )}
        </Modal>
    )
}

const AssetStoragePopover = ({children}) => {
    const {t} = useTranslation();
    const {selectedAssetIds, previouslySelectedAssetIds} = useSelectedAssetsState();
    const selectedAssetsDispatch = useSelectedAssetsDispatch();

    const ability = useContext(AbilityContext);

    const {aggs: searchAggs, total: totalAssets} = useAggsState()
    useFacets(['type']);
    const {selectedAssetAggs} = useSelectedAggsState()
    const {setFilters, removeFilter} = useFilters()

    const clickType = type => {
        setFilters(true, {type})
    }

    const [csvModalOpen, setCsvModalOpen] = useState(false)

    const clickUndoDeselect = ()=>{
        selectedAssetsDispatch({type:'undoSelectNone'})
    }

    const {getAllIds} = useSelectAll()

    const [selectingInverse, setSelectingInverse] = useState()
    const clickSelectInverse = ()=>{
        setSelectingInverse(true)
        getAllIds(ids => {
            setSelectingInverse(false)
            selectedAssetsDispatch({type:'setSelection', ids: ids.filter(id => !selectedAssetIds.includes(id))})
        })
    }

    const toggleSelectionFilter = (selection, value) => {
        const applied = filters.selection === selection

        if(!value && applied) {
            removeFilter('selection')
        } else {
            setFilters(false, {selection})
        }
    }

    const onShowSelectedAssetsChange = value => {
        toggleSelectionFilter('selected', value)
    }

    const onShowUnselectedAssetsChange = value => {
        toggleSelectionFilter('unselected', value)
    }

    if(!searchAggs?.type) return children

    const descriptions = (aggs, title) => {
        let count = 0
        let total = 0

        return (
            <Descriptions bordered size='small' column={1} title={title}>
                {aggs.type.buckets.map(bucket => {
                    const icon = {
                        Image: <FileImageOutlined/>,
                        Video: <VideoCameraOutlined/>,
                        Document: <FileOutlined/>,
                        Audio: <AudioOutlined/>,
                        Font: <FontSizeOutlined/>,
                        Text: <FileTextOutlined/>,
                    }[bucket.key] || <></>

                    const type = {
                        Image: 'images',
                        Video: 'videos',
                        Document: 'documents',
                        Audio: 'audio',
                        Font: 'fonts',
                        Text: 'text'
                    }[bucket.key]

                    if(!type) {
                        console.log('type null', bucket)
                        return <div key={'null'}></div>;
                    }

                    count += bucket.doc_count
                    total += bucket.file_size.value

                    return (
                        <Descriptions.Item
                            key={bucket.key}
                            label={<>{icon} <a onClick={()=> clickType(type)} className='asset-type-filter'>{t(type, bucket.key + 's')}</a></>}
                        >
                            {n(bucket.doc_count)} <small><Typography.Text type={'secondary'}>({filesize(bucket.file_size.value)})</Typography.Text></small>
                        </Descriptions.Item>
                    )
                })}
                <Descriptions.Item key={'total'} label={<><Typography.Text strong>{t('total','Total')}</Typography.Text></>}>
                    {n(count)} <small> <Typography.Text type={'secondary'}> ({filesize(total)}) </Typography.Text> </small>
                </Descriptions.Item>
            </Descriptions>
        )
    }

    return (
        <Popover
            placement={'bottomRight'}
            autoAdjustOverflow={false}
            overlayStyle={{minWidth:300}}
            trigger={['hover','click']}
            getPopupContainer={e => e.parentElement}
            content={
                <VerticalSpace>
                    {(!!selectedAssetIds.length || filters.selection) && (
                        <div style={{margin:'1em 0'}}>
                            <div style={{display:'flex',margin:'.5em 0'}}>
                                <Switch checked={filters.selection === 'selected'} checkedChildren={<CheckOutlined/>} onChange={onShowSelectedAssetsChange} aria-label={t('view-selected','View Selected')}/>
                                <span>&nbsp;{t('view-selected','View Selected')}</span>
                                <Tag style={{marginLeft:'auto'}}>{selectedAssetIds.length}</Tag>
                            </div>
                            <div style={{display:'flex',margin:'.5em 0'}}>
                                <Switch checked={filters.selection === 'unselected'} checkedChildren={<EyeInvisibleOutlined/>} onChange={onShowUnselectedAssetsChange} aria-label={t('view-unselected','View Unselected')}/>
                                <span>&nbsp;{t('view-unselected','View Unselected')}</span>
                                <Tag style={{marginLeft:'auto'}}>{Math.max(totalAssets - selectedAssetIds.length,0)}</Tag>
                            </div>
                        </div>
                    )}

                    {!!selectedAssetIds.length && (
                        <Button block ghost type={'primary'} onClick={clickSelectInverse} icon={<RetweetOutlined />} loading={selectingInverse}>
                            {t('button-select-inverse','Select Inverse')} &nbsp;<Tag>{Math.max(totalAssets - selectedAssetIds.length, 0)}</Tag>
                        </Button>
                    )}

                    {!!previouslySelectedAssetIds?.length && (
                        <Button block ghost danger onClick={clickUndoDeselect} icon={<UndoOutlined />}>
                            {t('button-undo-deselect','Undo Deselect')} &nbsp;<Tag>{previouslySelectedAssetIds.length}</Tag>
                        </Button>
                    )}

                    {(!!previouslySelectedAssetIds?.length || !!selectedAssetIds.length) && <Divider style={{margin:'1em 0'}}/>}

                    {!!selectedAssetIds.length && selectedAssetIds.length != totalAssets && (
                        <>
                            {selectedAssetAggs?.type && (
                                <>
                                    {descriptions(selectedAssetAggs, <><CheckOutlined/> {t('selected-assets','Selected Assets')}</>)}
                                    <Divider style={{margin:'.5em 0'}}/>
                                </>
                            )}
                        </>
                    )}

                    {descriptions(searchAggs, <><SearchOutlined/> {t('search-results','Search Results')} <Tooltip title={t('tooltip-search-results-storage','Includes processed, non-trashed content only; plan usage also counts stored versions that are still processing.')}><InfoCircleOutlined/></Tooltip></>)}

                    {ability.can('download_meta', 'Asset') && !!selectedAssetIds.length && (
                        <>
                            <Button
                                onClick={() => setCsvModalOpen(true)}
                                type={'primary'}
                                icon={<DownloadOutlined/>}
                                block
                            >
                                {t('button-download-csv','Download CSV')}
                            </Button>
                            <CsvDownloadModal
                                open={csvModalOpen}
                                onClose={() => setCsvModalOpen(false)}
                                assetIds={selectedAssetIds}
                            />
                        </>
                    )}
                </VerticalSpace>
            }
        >
            {children}
        </Popover>
    )
}

const BulkActionsButton = ({})=> {
    return (
        <IsolatedDiv>
            <BulkEditAssetMenu trigger={['click', 'hover']}>
                <Button icon={<SettingOutlined/>} size={'small'} type={'text'} id={'bulk-action-btn'}/>
            </BulkEditAssetMenu>
        </IsolatedDiv>
    )
}
